<template>
  <v-content v-if="recentQuotes">
    <Header title="Recent quotes">
      <p>
        This page lists conveyancing quotes which have been generated from your
        computer in the last 30 days. Click the view button on the list next to
        the quote you wish to retrieve.
      </p>
    </Header>
    <v-container>
      <v-card v-for="recentQuote in recentQuotes" :key="recentQuote.quoteId">
        <v-card-text>
          {{ recentQuote.quoteId }} {{ recentQuote.heading }}
          <span style="font-size: 0.9em; color: gray">{{
            recentQuote.stamp | formatDate
          }}</span>
          <v-btn
            small
            :to="{
              name: 'quotation',
              params: {
                salesUid: $cookies.get('salesUid'),
                quoteId: recentQuote.quoteId
              }
            }"
            color="success"
          >
            <span class="mr-2">View</span>
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import Header from "@/components/Header";
import nbmlaw from "@/apis/nbmlaw";
import cookie from "@/components/cookie.js";
export default {
  name: "RecentQuotes",
  components: { Header },
  mixins: [cookie],
  data() {
    return {
      recentQuotes: null
    };
  },
  methods: {
    async fetchRecentQuotes() {
      try {
        const response = await nbmlaw.get("/cors/open/sales/recent", {
          params: { salesUid: this.$cookies.get("salesUid") }
        });
        // console.log(response.data);
        this.recentQuotes = response.data;
      } catch (err) {
        console.log(err);
      }
    }
  },
  created() {
    this.fetchCookie();
    this.fetchRecentQuotes();
  }
};
</script>

<style>
</style>